module.exports = __webpack_public_path__ + "media/images/footer/en_ef-e648747fae8df4da6982582b21a47053.svg";